module.exports = __webpack_public_path__ + "static/long-term-goals_2-d6b792b60fcc3ea39717ce2e328f40a5.jpg";